import { render, staticRenderFns } from "./SaleReturnProductsLayout.vue?vue&type=template&id=33bd27c4&scoped=true&"
import script from "./SaleReturnProductsLayout.vue?vue&type=script&lang=js&"
export * from "./SaleReturnProductsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SaleReturnProductsLayout.vue?vue&type=style&index=0&id=33bd27c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd27c4",
  null
  
)

component.options.__file = "SaleReturnProductsLayout.vue"
export default component.exports